module.exports = __webpack_public_path__ + "img/Aura.04564f8a.png";